import api from "../api/axios";

const SettlementService = {
    createSettlement: async (settlementDto) => {
        const res = await api.post("settlements", settlementDto);
        return res.data;
    },
    getSettlements: async () => {
        const res = await api.get("settlements");
        return res.data.data || res.data;
    },
    getSettlementById: async (id) => {
        const res = await api.get(`settlements/${id}`);
        return res.data.data || res.data;
    },
    updateSettlement: async (settlementDto) => {
        const res = await api.post("settlements/update", settlementDto);
        return res.data;
    },
    deleteSettlement: async (id) => {
        const res = await api.delete(`settlements/${id}`);
        return res.data;
    }
};

export default SettlementService;
